<div class="dashboard-page student-dashboard">

  @if (toastMsg()) {
    <div class="td-toast" role="status">
      <i class="bi bi-check-circle-fill me-2"></i>{{ toastMsg() }}
    </div>
  }

  <!-- Page Header -->
  <div class="page-header">
    <div class="sd-identity">
      <div class="sd-avatar">{{ student.avatar }}</div>
      <div>
        <h1 class="page-title">Student Dashboard</h1>
        <p class="page-subtitle">
          Track your transport details, fee, library, books and assignments
          &nbsp;·&nbsp;
          <i class="bi bi-person-badge me-1"></i>{{ student.name }} · {{ student.programme }}
          &nbsp;·&nbsp;
          Roll No {{ student.roll_no }}
        </p>
      </div>
    </div>
    <!-- <div class="d-flex gap-2 align-items-center flex-wrap">
      <a [routerLink]="'/timetable'" class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2">
        <i class="bi bi-calendar-week"></i>
        <span class="d-none d-sm-inline">My Timetable</span>
      </a>
      <a [routerLink]="'/fees'" class="btn btn-primary-erp btn-sm d-flex align-items-center gap-2">
        <i class="bi bi-cash-coin"></i>
        <span class="d-none d-sm-inline">Pay Fees</span>
      </a>
    </div> -->
  </div>

  <!-- Row: Attendance / Today / Holidays -->
  <div class="row g-3 mb-4">
    <div class="col-md-6 col-xl-4">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-pie-chart-fill me-2 text-primary"></i>Cumulative Attendance</h6>
        </div>
        <div class="dash-card-body sd-attendance-body">
          <div class="donut-container mb-0">
            <svg viewBox="0 0 100 100" class="donut-svg">
              <circle cx="50" cy="50" r="44" fill="none" stroke="#e5e7eb" stroke-width="8"></circle>
              <circle cx="50" cy="50" r="44" fill="none" stroke="#22c55e" stroke-width="8"
                [attr.stroke-dasharray]="attendanceDash"
                stroke-linecap="round"></circle>
              <text x="50" y="70" text-anchor="middle" font-size="16" font-weight="700" fill="#111827">{{ attendancePct }}%</text>
              <text x="50" y="82" text-anchor="middle" font-size="8" fill="#6b7280">Present</text>
            </svg>
          </div>
          <div class="sd-att-copy">
            <div class="stat-value">{{ attendancePct }}% Present</div>
            <span class="standing-pill" *ngIf="attendancePct >= 50"><i class="bi bi-check2-circle me-1"></i>Good Standing</span>
            <span class="loose-pill" *ngIf="attendancePct < 50"><i class="bi bi-exclamation-circle me-1"></i>Need more presence</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-xl-4">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-calendar-check-fill me-2 text-success"></i>Today’s Status</h6>
          <span class="card-badge">{{ currentDate | date:'EEE, MMM d' }}</span>
        </div>
        <div class="dash-card-body sd-today-body flex-column">
          <div class="d-flex flex-row justify-content-between">
            <div class="today-check me-3" [class.is-absent]="todayPresent!='Present'">
              <i class="bi" [class.bi-check-lg]="todayPresent=='Present'" [class.bi-x-lg]="todayPresent!='Present'"></i>
            </div>
            <div>
              <div class="today-status-label">{{ todayPresent || 'Missed' }}</div>
              <div class="today-course">{{ todayCourse }} · {{ todayCourseTime }}</div>
            </div>
          </div>
          <button class="btn btn-primary-erp w-100 justify-content-center" (click)="openLeaveModal()">
            <i class="bi bi-plus-lg"></i> Request Leave
          </button>
        </div>
      </div>
    </div>

    <div class="col-xl-4">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-calendar-event-fill me-2 text-info"></i>Upcoming Holidays</h6>
        </div>
        <div class="dash-card-body">
          <ul class="holiday-list">
            @for (day of holidays; track day.title) {
              <li class="holiday-item">
                <div class="holiday-icon"><i class="bi bi-calendar2-week"></i></div>
                <div>
                  <div class="holiday-date">{{ day.datelabel }}</div>
                  <div class="holiday-title">{{ day.title }}</div>
                </div>
              </li>
            }
            @empty {
              No Holiday!
            }
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Row: Leaves -->
  <div class="row g-3 mb-4">
    <div class="col-lg-4">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-calendar-check me-2 text-purple"></i>My Todo</h6>
        </div>
        <div class="dash-card-body d-flex flex-column justify-content-between gap-3"
          style="max-height: 190px; overflow: auto;">
          <app-todo [stats]="false"  [title]="false"></app-todo>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-clock-history me-2 text-warning"></i>Attendance Report</h6>
          <span class="card-badge">{{ pendingLeaveCount() }} open</span>
        </div>
        <div class="dash-card-body p-0">
          <div class="table-responsive">
            <table class="erp-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Period</th>
                  <th>Status</th>
                  <th class="d-none d-md-table-cell">Remark</th>
                  <!-- <th>Status</th> -->
                </tr>
              </thead>
              <tbody>
                @for (asts of att_status; track asts.id) {
                  <tr>
                    <td class="fw-semibold">{{ asts.datelabel }}</td>
                    <td>{{ asts.att_period }}</td>
                    <td>{{ asts.att_status }}</td>
                    <td class="d-none d-md-table-cell">{{ asts.remark }}</td>
                    <!-- <td><span class="status-badge {{ getStatusClass(leave.status) }}">{{ leave.status }}</span></td> -->
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-2">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title">
            <i class="bi bi-card-list me-2 text-success"></i>
            Att. Status
          </h6>
        </div>
        <div class="dash-card-body d-flex flex-column justify-content-between">
          <div class="asb-row">
            <div class="asb-dot present"></div><span>Present</span><span class="ms-auto fw-bold text-success">{{
              markSummary.present }}</span>
          </div>
          <div class="asb-row">
            <div class="asb-dot absent"></div><span>Absent</span><span class="ms-auto fw-bold text-danger">{{
              markSummary.absent }}</span>
          </div>
          <div class="asb-row">
            <div class="asb-dot late"></div><span>Late</span><span class="ms-auto fw-bold text-warning">{{
              markSummary.late }}</span>
          </div>
          <div class="asb-row">
            <div class="asb-dot halfday"></div><span>Half-Day</span><span class="ms-auto fw-bold text-info">{{
              markSummary.half_day }}</span>
          </div>
          <div class="asb-row">
            <div class="asb-dot leave"></div><span>On Leave</span><span class="ms-auto fw-bold text-purple">{{
              markSummary.on_leave }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Row: Transport -->
  <div class="row g-3 mb-4">
    <div class="col-lg-4">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-bus-front-fill me-2 text-warning"></i>My Transport Details</h6>
          <a [routerLink]="'/transport'" class="view-all-link">View All <i class="bi bi-arrow-right"></i></a>
        </div>
        <div class="dash-card-body">
          <div class="transport-layout">
            <div class="bus-art" aria-hidden="true">
              <i class="bi bi-bus-front"></i>
            </div>
            <dl class="detail-list">
              <div><dt>Bus Number</dt><dd>{{ transport.bus_number }}</dd></div>
              <div><dt>Route Name</dt><dd>{{ transport.route_name }}</dd></div>
              <div><dt>Pick-Up Point</dt><dd>{{ transport.pickup_point }}</dd></div>
              <div><dt>Pick-Up Time</dt><dd>{{ transport.pickup_time }}</dd></div>
              <div><dt>Driver Name</dt><dd>{{ transport.driver_name }}</dd></div>
              <div><dt>Mobile No.</dt><dd>{{ transport.mobile }}</dd></div>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-shield-check me-2 text-success"></i>Transport Status</h6>
        </div>
        <div class="dash-card-body d-flex flex-column gap-3">
          <div class="status-callout callout-success">
            <div class="callout-icon"><i class="bi bi-ticket-perforated-fill"></i></div>
            <div>
              <div class="callout-title">Transport Ticket Today</div>
              <p class="callout-text">You have valid transport access today.</p>
            </div>
          </div>
          <div class="status-callout callout-warning">
            <div class="callout-icon"><i class="bi bi-exclamation-circle-fill"></i></div>
            <div>
              <div class="callout-title">Transport Gap Months</div>
              <p class="callout-text">
                @if (transport.gap_months === 0) {
                  No gap months. You have been using transport continuously this year.
                } @else {
                  {{ transport.gap_months }} gap month(s) this year.
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-wallet2 me-2 text-danger"></i>Upcoming Payment</h6>
          <a [routerLink]="'/fees'" class="view-all-link">View All <i class="bi bi-arrow-right"></i></a>
        </div>
        <div class="dash-card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <div class="pay-kicker">{{ upcomingPayment().title }}</div>
              <div class="pay-amount">₹ {{ upcomingPayment().amount | number:'1.0-0' }}</div>
            </div>
            <div class="pay-meta">
              @if (upcomingPayment().status === 'Unpaid') {
                <span class="due-chip">Due in {{ paymentDueInDays() }} day{{ paymentDueInDays() === 1 ? '' : 's' }}</span>
              <!-- } @else {
                <span class="status-badge badge-approved">Paid</span> -->
              }
            </div>
          </div>
          <dl class="detail-list mt-3">
            <div><dt>Due Date</dt><dd>{{ upcomingPayment().due_date | date:'dd MMM y' }}</dd></div>
            <div>
              <dt>Payment Status</dt>
              <dd>
                <span class="status-badge {{ getStatusClass(upcomingPayment().status) }}">
                  {{ upcomingPayment().status === 'Unpaid' ? 'Unpaid – Need to pay' : 'Paid' }}
                </span>
              </dd>
            </div>
          </dl>
          @if (upcomingPayment().status === 'Unpaid') {
            <button class="btn btn-sm btn-primary-erp w-100 mt-2" (click)="payTransport()">
              <i class="bi bi-credit-card-2-front-fill"></i> Pay Now
            </button>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Row: Library / Homework / Gate Pass -->
  <div class="row g-3 mb-4">
    <div class="col-xl-3 col-lg-4">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title">
            <i class="bi bi-journal-bookmark-fill me-2 text-danger"></i>Fee Pay Bill - {{fee_str.academic_year}}
          </h6>
        </div>
        <div class="dash-card-body">
          <div class="lib-balance">
            <span>Current Balance</span>
            <strong>₹{{ fee_str.balance || (fee_str.total_amount - fee_str.total_paid) | number }}</strong>
          </div>
          <ul class="ledger-list">
            @for(fs of fee_str.items; track $index) {
              <!-- {{fs|json}} -->
            <li>
              <span>{{fs.fee_head_name}}</span>
              <span>₹{{ fs.amount || fs.due_amount | number }}</span>
            </li>
            }
            <li class="total"><span>Total Charges</span><span>₹{{ fee_str.total_amount | number }}</span></li>

            <li><span>Total Paid</span><span>₹{{ fee_str.total_paid || 0 | number }}</span></li>
            <li class="outstanding"><span>Outstanding</span><span>₹{{ (fee_str.total_amount - fee_str.total_paid) | number }}</span></li>
          </ul>
          <button class="btn btn-primary-erp w-100 mt-3" [disabled]="fee_str.balance==0" (click)="payLibrary()"
            style="height: 36px;">
            <i class="bi bi-wallet2 me-1"></i>Pay Outstanding Full
          </button>
          <button class="btn btn-outline-secondary w-100 mt-2" 
            style="height: 34px; font-size: 0.85rem; font-weight: 500;">
            <i class="bi bi-receipt me-1"></i>Payment Receipt
          </button>
          <!-- <div class="mt-4 d-flex gap-3 flex-wrap">
            <div class="a-links"><i class="bi bi-clock-history me-1"></i>Payment History</div>
            <div class="a-links"><i class="bi bi-receipt me-1"></i>Payment Receipt</div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="col-xl-5 col-lg-8">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-journal-check me-2 text-success"></i>Homework / Assignments</h6>
          <!-- <input type="date" class="form-control form-control-sm hw-date" [ngModel]="homeworkDate()" (ngModelChange)="homeworkDate.set($event)"> -->
        </div>
        <div class="dash-card-body">
          <div class="hw-stats">
            <div class="hw-stat danger" title="Active / Pending">
              <span>Assignments</span>
              <strong>{{ activeHomeworkCount() }}</strong>
            </div>
            <div class="hw-stat warning">
              <span>Overdue</span>
              <strong>{{ overdueHomeworkCount() }}</strong>
            </div>
          </div>
          <div class="hw-section-label">Active Homework / Assignments</div>
          <ul class="hw-list">
            @for (item of homework(); track item.id) {
              <li class="hw-item">
                <div class="d-flex justify-content-between gap-2 mb-1">
                  <div>
                    <div class="hw-title">{{ item.title }}</div>
                    <div class="hw-meta">{{ item.subject }} · Due {{ item.due_date | date:'MMM d, y' }}</div>
                  </div>
                  <span class="status-badge {{ getStatusClass(item.status) }}">{{ item.status }}</span>
                </div>
                <div class="d-flex align-items-center gap-2 mt-2">
                  <div class="progress flex-grow-1" style="height: 7px; border-radius: 4px;">
                    <div class="progress-bar" [style.width.%]="item.progress"
                      [style.background]="item.status === 'Not Complete' && item.due_date < todayIso() ? '#ef4444' : 'linear-gradient(90deg,#1a3a6b,#2d6a9f)'"></div>
                  </div>
                  <span class="small fw-semibold">{{ item.progress }}%</span>
                </div>
                <!-- <div class="hw-actions">
                  <a [routerLink]="'/homework'" class="btn btn-sm btn-outline-secondary">View Details</a>
                  @if (item.status === 'Not Complete') {
                    <button class="btn btn-sm btn-primary-erp" (click)="submitHomework(item)">Submit</button>
                  }
                </div> -->
              </li>
            }
          </ul>
        </div>
      </div>
    </div>

    <div class="col-xl-4">
      <div class="dash-card h-100 gate-card">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-pass-fill me-2"></i>Active / Pending Gate Pass</h6>
        </div>
        <div class="dash-card-body">
          @if (activePass(); as pass) {
            <div class="active-pass">
              <div class="pass-kicker">Active Pass</div>
              <div class="pass-grid">
                <div class="qr-code" aria-hidden="true">
                  @for (cell of qrCells; track $index) {
                    <span [class.on]="cell"></span>
                  }
                </div>
                <dl class="detail-list">
                  <div><dt>Student Name</dt><dd>{{ pass.student_name }}</dd></div>
                  <div><dt>Pass ID</dt><dd>{{ pass.pass_id }}</dd></div>
                  <div><dt>Destination</dt><dd>{{ pass.destination }}</dd></div>
                  <div><dt>Date</dt><dd>{{ pass.date | date:'MMM d, y' }}</dd></div>
                  <div><dt>Out Time</dt><dd>{{ pass.date | date:'MMM d' }}, {{ pass.out_from }}–{{ pass.out_to }}</dd></div>
                </dl>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <span class="status-badge {{ getStatusClass(pass.status) }}">{{ pass.status }}</span>
                <button class="btn btn-sm btn-outline-secondary py-0" (click)="openPassModal()">Request New Pass</button>
              </div>
            </div>
          }
          <div class="pass-kicker mt-3">Pass History</div>
          <ul class="pass-history">
            @for (pass of passHistory(); track pass.id) {
              <li>
                <div>
                  <div class="student-name">{{ pass.student_name }}</div>
                  <div class="hw-meta">{{ pass.destination }} · {{ pass.date | date:'MMM d, y' }} · {{ pass.out_from }}–{{ pass.out_to }}</div>
                </div>
                <span class="status-badge {{ getStatusClass(pass.status) }}">{{ pass.status }}</span>
              </li>
            }
            @empty() {
              <li>No past history!</li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Row: Payments / Activity -->
  <div class="row g-3 mb-4">
    <div class="col-lg-7">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-receipt-cutoff me-2 text-primary"></i>FEE Payment History</h6>
          <a [routerLink]="'/fees'" class="view-all-link">View All <i class="bi bi-arrow-right"></i></a>
        </div>
        <div class="dash-card-body p-0">
          <div class="table-responsive">
            <table class="erp-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Transaction ID</th>
                  <th>Amount</th>
                  <th class="d-none d-md-table-cell">Payment Mode</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                @for (row of payments(); track row.txn_id) {
                  <tr>
                    <td>{{ row.date | date:'dd MMM y' }}</td>
                    <td class="font-mono">{{ row.txn_id }}</td>
                    <td>₹{{ row.amount | number }}</td>
                    <td class="d-none d-md-table-cell">{{ row.mode }}</td>
                    <td><span class="status-badge {{ getStatusClass(row.status) }}">{{ row.status }}</span></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-5">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-bell-fill me-2 text-info"></i>Recent Activity &amp; Notifications</h6>
          <a [routerLink]="'/notifications'" class="view-all-link">View All <i class="bi bi-arrow-right"></i></a>
        </div>
        <div class="dash-card-body">
          <ul class="notice-list">
            @for (item of activities(); track item.text) {
              <li class="notice-item">
                <span class="notice-dot bg-{{ item.tone }}"></span>
                <div>
                  <p class="notice-text">{{ item.text }}</p>
                  <span class="notice-date">{{ item.time }}</span>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Row: Periods + weekly schedule + actions -->
  <div class="row g-3 mb-4">
    <div class="col-xl-9">
      <div class="period-banners mb-3">
        <div class="period-banner current" [class.is-idle]="!currentSlot()">
          <div class="period-kicker">Current Period</div>
          @if (currentSlot(); as slot) {
            <div class="period-title">{{ formatTime(slot.start) }} – {{ formatTime(slot.end) }} | {{ slot?.subject }} ({{ slot?.code }}) · {{ slot?.room }}</div>
            <div class="period-sub">{{ currentProgress() }}% Complete · Lecture by {{ slot?.teacher }}</div>
            <div class="progress mt-2" style="height: 6px; border-radius: 6px; background: rgba(255,255,255,.25);">
              <div class="progress-bar bg-white" [style.width.%]="currentProgress()"></div>
            </div>
          } @else {
            <div class="period-title">No class in session</div>
            <div class="period-sub">You’re between periods or outside teaching hours.</div>
          }
        </div>
        <div class="period-banner next">
          <div class="period-kicker">Next Period</div>
          @if (nextSlot(); as slot) {
            <div class="period-title">{{ formatTime(slot.start) }} – {{ formatTime(slot.end) }}</div>
            <div class="period-sub">{{ slot?.subject }} ({{ slot?.code }}) · {{ slot?.room }}</div>
          } @else {
            <div class="period-title">No upcoming class today</div>
            <div class="period-sub">Check the weekly schedule for the rest of the week.</div>
          }
        </div>
      </div>

      <div class="dash-card">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-calendar3 me-2 text-primary"></i>Weekly Schedule ({{weekTimes()[0]?.start}} AM - {{weekTimes()[weekTimes()?.length-1]?.end}} PM)</h6>
        </div>
        <div class="dash-card-body p-0" style="overflow-x: auto;">
          <div class="week-grid" role="table" aria-label="Weekly class schedule">
            <div class="week-corner"></div>
            @for (day of weekDays; track day) {
              <div class="week-day">{{ day }}</div>
            }
            @for (time of weekTimes(); track time.start) {
              <div class="week-time" title="{{ time?.start }} to {{ time?.end }}">{{ time?.start }}</div>
              @for (day of weekDays; track day) {
                @if (slotAt(day, time?.start); as slot) {
                  <div class="week-cell filled" [class.is-now]="currentSlot()?.day === day && currentSlot()?.start === slot?.start">
                    <div class="cell-subject">{{ slot.subject }}</div>
                    <div class="cell-meta">{{ slot.code }} · {{ slot.teacher }} · {{ slot.room }}</div>
                  </div>
                } @else {
                  <div class="week-cell d-flex justify-content-center align-items-center">
                    @if(time.is_break) {
                      <small>{{time.break_label}}</small>
                    }
                  </div>
                }
              }
            }
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3">
      <div class="dash-card mb-3">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-lightning-charge-fill me-2 text-warning"></i>Quick Actions</h6>
        </div>
        <div class="dash-card-body d-flex flex-column gap-2">
          <a [routerLink]="quickActions[0].route" class="side-action">
            <i class="bi {{ quickActions[0].icon }}"></i>{{ quickActions[0].label }}
          </a>
          <button type="button" class="side-action" (click)="requestSwap()">
            <i class="bi {{ quickActions[1].icon }}"></i>{{ quickActions[1].label }}
          </button>
          <button type="button" class="side-action" (click)="downloadSyllabus()">
            <i class="bi {{ quickActions[2].icon }}"></i>{{ quickActions[2].label }}
          </button>
        </div>
      </div>

      <div class="dash-card">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-file-earmark-text-fill me-2 text-info"></i>Lecture Notes</h6>
        </div>
        <div class="dash-card-body p-0">
          <ul class="notes-list">
            @for (note of lectureNotes; track note.title) {
              <li>
                <button type="button" (click)="downloadNote(note)">
                  <i class="bi {{ note.icon }}"></i>
                  <span>{{ note.title }}</span>
                  <em>{{ note.type }}</em>
                </button>
              </li>
            }
            @empty() {
              <li class="py-2 px-3">No document found!</li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Row: Fee query / tickets -->
  <div class="row g-3 mb-2">
    <div class="col-lg-7">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-chat-left-quote-fill me-2 text-primary"></i>Raise a fee query</h6>
        </div>
        <div class="dash-card-body">
          <p class="query-hint">Goes straight to the accounts department. Typical first response: one working day.</p>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label fw-semibold">Concern type</label>
              <select class="form-select" [(ngModel)]="queryForm.concern_type">
                @for (type of concernTypes; track type) {
                  <option [value]="type">{{ type }}</option>
                }
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Invoice / transaction reference</label>
              <input class="form-control" [(ngModel)]="queryForm.invoice_ref" maxlength="40">
            </div>
            <div class="col-12">
              <label class="form-label fw-semibold">Details</label>
              <textarea class="form-control" rows="4" maxlength="500"
                [(ngModel)]="queryForm.details"
                placeholder="Describe the issue, including dates and amounts."
                [class.is-invalid]="querySubmitted && !queryForm.details.trim()"></textarea>
            </div>
            <div class="d-flex align-items-end justify-content-between">
              <div class="col-9">
                <label class="form-label fw-semibold">Attachments (up to 2MB)</label>
                <input type="file" class="form-control" (change)="onQueryFile($event)">
                <!-- <div class="form-text">Attachments up to 5 MB can be added after submission.{{ queryForm.file_name ? ' Selected: ' + queryForm.file_name : '' }}</div> -->
              </div>
              <button class="col-auto btn btn-primary-erp mt-3" (click)="submitQuery()" style="height: 38px;">
                <i class="bi bi-send-fill"></i> Submit!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-5">
      <div class="dash-card h-100">
        <div class="dash-card-header">
          <h6 class="dash-card-title"><i class="bi bi-ticket-detailed-fill me-2 text-success"></i>Your Tickets</h6>
        </div>
        <div class="dash-card-body">
          <ul class="ticket-list">
            @for (ticket of tickets(); track ticket.id) {
              <li class="ticket-item">
                <div>
                  <div class="ticket-no">{{ ticket.ticket_no }}</div>
                  <div class="student-name">{{ ticket.title }}</div>
                  <div class="hw-meta">{{ ticket.date | date:'d MMM y' }} · {{ ticket.assignee }}</div>
                </div>
                <span class="status-badge {{ getStatusClass(ticket.status) }}"
                  style="height: 24px; border-radius: 8px;">{{ ticket.status }}</span>
              </li>
            }
          </ul>
          <div class="accounts-desk">
            <div class="pass-kicker">Accounts desk</div>
            <p><i class="bi bi-telephone me-1"></i>+91 80 4210 9000 · Mon–Sat, 10:00–16:30</p>
            <p class="mb-0"><i class="bi bi-geo-alt me-1"></i>Accounts Desk · Block C, Room 04</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showLeaveModal()) {
  <div class="sd-overlay" (click)="showLeaveModal.set(false)">
    <div class="sd-modal" (click)="$event.stopPropagation()">
      <div class="sd-modal-h">
        <h5>Request Leave</h5>
        <button class="btn btn-sm btn-outline-light" (click)="showLeaveModal.set(false)"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="sd-modal-b">
        <div class="row g-3">
          <div class="col-12">
            <label class="form-label fw-semibold">Leave type</label>
            <select class="form-select" [(ngModel)]="leaveForm.request_type">
              @for (type of leaveTypes; track type) {
                <option [value]="type">{{ type }}</option>
              }
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label fw-semibold">From</label>
            <input type="date" class="form-control" [(ngModel)]="leaveForm.from_date" [class.is-invalid]="leaveSubmitted && !leaveForm.from_date">
          </div>
          <div class="col-md-6">
            <label class="form-label fw-semibold">To</label>
            <input type="date" class="form-control" [(ngModel)]="leaveForm.to_date" [class.is-invalid]="leaveSubmitted && !leaveForm.to_date">
          </div>
          <div class="col-12">
            <label class="form-label fw-semibold">Reason</label>
            <textarea class="form-control" rows="3" [(ngModel)]="leaveForm.reason"
              [class.is-invalid]="leaveSubmitted && !leaveForm.reason.trim()"></textarea>
          </div>
        </div>
      </div>
      <div class="sd-modal-f">
        <button class="btn btn-outline-secondary" (click)="showLeaveModal.set(false)">Cancel</button>
        <button class="btn btn-primary-erp" (click)="submitLeave()">Submit request</button>
      </div>
    </div>
  </div>
}

@if (showPassModal()) {
  <div class="sd-overlay" (click)="showPassModal.set(false)">
    <div class="sd-modal" (click)="$event.stopPropagation()">
      <div class="sd-modal-h">
        <h5>Request New Gate Pass</h5>
        <button class="btn btn-sm btn-outline-light" (click)="showPassModal.set(false)"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="sd-modal-b">
        <div class="row g-3">
          <div class="col-12">
            <label class="form-label fw-semibold">Destination</label>
            <input class="form-control" [(ngModel)]="passForm.destination" [class.is-invalid]="passSubmitted && !passForm.destination.trim()">
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Date</label>
            <input type="date" class="form-control" [(ngModel)]="passForm.date">
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Out from</label>
            <input type="time" class="form-control" [(ngModel)]="passForm.out_from">
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Out to</label>
            <input type="time" class="form-control" [(ngModel)]="passForm.out_to">
          </div>
          <div class="col-12">
            <label class="form-label fw-semibold">Reason</label>
            <textarea class="form-control" rows="2" [(ngModel)]="passForm.reason"></textarea>
          </div>
        </div>
      </div>
      <div class="sd-modal-f">
        <button class="btn btn-outline-secondary" (click)="showPassModal.set(false)">Cancel</button>
        <button class="btn btn-primary-erp" (click)="submitPass()">Send for approval</button>
      </div>
    </div>
  </div>
}
